import { Props } from '@/pages/platform/board'
// import Mobile from '@/mobile-pages/board'
import useIsMobile from '@/hooks/useIsMobile'
import dynamic from 'next/dynamic'

const PC = dynamic(() => import('@/pages/platform/board'))
const Mobile = dynamic(() => import('@/mobile-pages/board'))

const Board = (props: Props) => {
  return useIsMobile() ? <Mobile {...props} /> : <PC {...props} />
}

export { getServerSideProps } from '@/pages/platform/board'

export default Board
